export enum IndustryCategories {
    Agriculture,
    Apparel,
    Banking,
    Biotechnology,
    BusinessServices,
    Chemicals,
    Communications,
    Construction,
    Consulting,
    Education,
    Electronics,
    Energy,
    Engineering,
    Entertainment,
    Finance,
    FoodAndBeverage,
    Government,
    HealthcareAndPharmaceuticals,
    Hospitality,
    Insurance,
    Legal,
    Machinery,
    Manufacturing,
    Marketing,
    Media,
    NotForProfit,
    ProfessionalServices,
    RealEstate,
    RecreationAndTravel,
    Recruitment,
    Retail,
    Shipping,
    Technology,
    Telecommunications,
    Transportation,
    Utilities,
}


// Relationship Types
export enum BusinessRelationshipTypes {
    Accountant,
    AccountingDeliveryPartner,
    Actuary,
    Ambassador,
    Client,
    Competitor,
    Contact,
    DeliveryPartner,
    EnvironmentalConsultants,
    EnvironmentalServicesDeliveryPartner,
    FormerClient,
    HedgeFund,
    InsuranceBroker,
    Lawyer,
    LegalDeliveryPartner,
    MediaProvider,
    PotentialPurchaser,
    PR,
    PRDeliveryPartner,
    PrivateBankWealthManagement,
    PrivateBankDeliveryPartner,
    PrivateEquity,
    PrivateEquityDeliveryPartner,
    Prospect,
    StrategyDeliveryPartner,
    Supplier,
    TaxAdvisers,
    TaxDeliveryPartner,
    SmallBusinessInvestor,
}


export enum OpportunitySourceTypes {
    Advertisement,
    //Beauhurst,
    DeliveryPartner,
    EmployeeReferral,
    //EventBrite,
    ExternalNetworkingEvent,
    ExternalReferral,
    //FOREBusiness,
    GeneralNetworking,
    //IODInserts,
    LinkedIn,
    MailingList,
    //OriginationScheme,
    PersonalContact,
    PreviousClientReferral,
    PublicRelations,
    ReferralFromAccountantSolicitor,
    Seminar,
    SeminarFocus,
    SocialMedia,
    WebSearch,
    Website,
    WordOfMouth
}

export enum InvestmentTypes {
    B2B = 'B2B',
    B2C = 'B2C',
    None = 'None',
    Neither = 'Neither'
}

export enum InvestorTypes {
    Corporate,
    PrivateEquityBuyout,
    VentureCapital,
    CorporateVentureCapital,
    FamilyOffice,
    HighNetWorth,
    Other
}


export enum InvestmentPreferredDealTypes {
    Acquisition,
    Buyout,
    MBO,
    MBI,
    PEGrowthExpansion,
    LaterStageVC,
    EarlyStageVC,
    SeedRound,
    MEZZFinance
}

export enum InvestmentGeographicalPreferences {
    UK,
    Europe,
    Africa,
    Asia,
    Australasia,
    NorthAmerica,
    SouthAmerica,
}


// export enum CommunicationOutcomes {
//     SpokeToContactSuccess = 'Spoke to Contact - Successful call',
//     EngagedButWrongContact = 'Engaged conversation but not the right contact',
//     NoResponse = 'Called but no response',
//     WrongContactDetails = 'Wrong contact details',
// }

// Preferred Industries,
// Can use the same pick list as we already do for “Industry” but it would be good to then have “sub-industry” which we can populate ourselves for any specifics. I think this would be the easiest way,
export enum InvestmentPreferredCompanyValuations {
    From0To5MEuro = '€0m to €5m',
    From5To25MEuro = '€5m to €25m',
    From25To50MEuro = '€25m to €50m',
    From50To100MEuro = '€50m to €100m',
    From100To250MEuro = '€100m to €250m',
    GreaterThan250MEuro = 'Greater than €250m',
}

export enum InvestmentPreferredInvestmentAmounts {
    From0To500kEuro = '€0 to €500k',
    From500kTo1MEuro = '€500k to €1m',
    From1MTo5MEuro = '€1m to €5m',
    From5To25MEuro = '€5m to €25m',
    From25To50MEuro = '€25m to €50m',
    From50To100MEuro = '€50m to €100m',
    GreaterThan100MEuro = 'Greater than €100m',
}

export enum InvestmentPreferredRevenueCharacteristics {
    PreRevenue = 'Pre Revenue',
    PostRevenue = 'Post Revenue',
    RecurringRevenue = 'Recurring Revenue',
    GreaterThan1MRevenueEuro = 'Greater than €1m Revenue',
    GreaterThan5MRevenueEuro = 'Greater than €5m Revenue',
    GreaterThan10MRevenueEuro = 'Greater than €10m Revenue',
}

export enum InvestmentPreferredProfitCharacteristics {
    PreProfit = 'Pre Profit',
    Profitable = 'Profitable',
    GreaterThan1mEuroEBITDA = 'Greater than €1m EBITDA',
    GreaterThan2mEuroEBITDA = 'Greater than €2m EBITDA',
    GreaterThan5mEuroEBITDA = 'Greater than €5m EBITDA',
}




// WEBPACK FOOTER //
// ./client/app/features/companies/company.enums.ts